// frontend/src/components/QuickPhraseDropdown/QuickPhraseDropdown.js
import React, { useEffect, useRef } from 'react';
import './QuickPhraseDropdown.css';

/**
 * Dropdown component for quick phrase autocomplete
 * Shows when user types ; in a textarea
 */
function QuickPhraseDropdown({
  show,
  position,
  phrases,
  selectedIndex,
  searchQuery,
  onSelect,
  onClose,
  loading = false
}) {
  const dropdownRef = useRef(null);
  const selectedRef = useRef(null);

  // Scroll selected item into view
  useEffect(() => {
    if (selectedRef.current && dropdownRef.current) {
      selectedRef.current.scrollIntoView({
        block: 'nearest',
        behavior: 'smooth'
      });
    }
  }, [selectedIndex]);

  if (!show) return null;

  return (
    <div
      ref={dropdownRef}
      className="quick-phrase-dropdown"
      style={{
        top: position.top,
        left: position.left
      }}
    >
      <div className="quick-phrase-header">
        <span className="quick-phrase-icon">;</span>
        <span className="quick-phrase-title">
          {searchQuery ? `Sök: ${searchQuery}` : 'Snabbfraser'}
        </span>
        <button className="quick-phrase-close" onClick={onClose}>
          <i className="fas fa-times"></i>
        </button>
      </div>

      <div className="quick-phrase-list">
        {loading ? (
          <div className="quick-phrase-loading">
            <i className="fas fa-spinner fa-spin"></i>
            Laddar fraser...
          </div>
        ) : phrases.length === 0 ? (
          <div className="quick-phrase-empty">
            {searchQuery
              ? `Ingen fras matchar "${searchQuery}"`
              : 'Inga fraser tillagda'}
          </div>
        ) : (
          phrases.map((phrase, index) => (
            <div
              key={phrase.phrase_id}
              ref={index === selectedIndex ? selectedRef : null}
              className={`quick-phrase-item ${index === selectedIndex ? 'selected' : ''}`}
              onClick={() => onSelect(phrase)}
              onMouseEnter={() => {}} // Could update selectedIndex on hover
            >
              <div className="phrase-item-title">
                {highlightMatch(phrase.title, searchQuery)}
              </div>
              <div className="phrase-item-preview">
                {truncateText(phrase.phrase_text, 60)}
              </div>
            </div>
          ))
        )}
      </div>

      <div className="quick-phrase-footer">
        <span><kbd>↑</kbd><kbd>↓</kbd> navigera</span>
        <span><kbd>Tab</kbd>/<kbd>Enter</kbd> infoga</span>
        <span><kbd>Esc</kbd> stäng</span>
      </div>
    </div>
  );
}

// Helper to highlight matching text
function highlightMatch(text, query) {
  if (!query) return text;

  const index = text.toLowerCase().indexOf(query.toLowerCase());
  if (index === -1) return text;

  return (
    <>
      {text.substring(0, index)}
      <mark>{text.substring(index, index + query.length)}</mark>
      {text.substring(index + query.length)}
    </>
  );
}

// Helper to truncate text
function truncateText(text, maxLength) {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
}

export default QuickPhraseDropdown;
